import { fork, all } from 'redux-saga/effects';

import { pairs } from './pairs/actions';
import { tokens } from './tokens/actions';
import { limitations } from './limitations/actions';
import { fees } from './fees/actions';
import { currencies } from './currencies/actions';
import { robot } from './robot/actions';

export function* market() {
  yield all([
    fork(pairs),
    fork(tokens),
    fork(limitations),
    fork(fees),
    fork(currencies),
    fork(robot),
  ]);
}
